import watch   from "redux-watch";
import isEqual from 'is-equal';
import RiotEventManager   from 'utilities/riot/event_manager';
export default class ControllerBase extends RiotEventManager{
  constructor(tag) {
    super(tag);
  }
  protected dispatchNewValue(newVal: any) {
    App.store.dispatch(this.dispatchAction()(newVal));
  }

  protected dispatchAction(){
    return App.actions.data.update;
  }
}
